interface Props {
  values: number[];
  width?: number;
  height?: number;
  strokeClass?: string;
  fillClass?: string;
  pad?: number;
}

export default function Sparkline({
  values, width = 120, height = 32, strokeClass = 'stroke-accent-500', fillClass = 'fill-accent-500/15', pad = 2,
}: Props) {
  if (values.length === 0) return <div style={{ width, height }} />;
  const max = Math.max(1, ...values);
  const step = (width - pad * 2) / Math.max(1, values.length - 1);
  const points = values.map((v, i) => {
    const x = pad + i * step;
    const y = height - pad - (v / max) * (height - pad * 2);
    return [x, y] as const;
  });
  const path = points.map((p, i) => (i === 0 ? `M ${p[0]},${p[1]}` : `L ${p[0]},${p[1]}`)).join(' ');
  const area = `${path} L ${points[points.length - 1][0]},${height - pad} L ${points[0][0]},${height - pad} Z`;

  return (
    <svg width={width} height={height} className="block overflow-visible">
      <path d={area} className={fillClass} />
      <path d={path} className={strokeClass} fill="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
